import {useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import circle from '@turf/circle';

import { map } from './Map';

const AccuracyMap = () => {
    const id = 'accuracy';
    const mapboxControlRef = useRef(null);

    const positions = useSelector(state => ({
        type: 'FeatureCollection',
        features: Object.values(state.positions.items).filter(position => position.accuracy > 0).map(position =>
            circle([position.longitude, position.latitude], position.accuracy * 0.001)
        ),
    }));

    useEffect(() => {
        map.addSource(id, {
            'type': 'geojson',
            'data': {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            'source': id,
            'id': id,
            'type': 'fill',
            'filter': [
                'all',
                ['==', '$type', 'Polygon'],
            ],
            'paint': {
                'fill-color':'#3bb2d0',
                'fill-outline-color':'#3bb2d0',
                'fill-opacity':0.25,
            },
        });

        // Add refresh control
        const refreshControl = document.createElement('div');
        refreshControl.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        refreshControl.innerHTML = `
      <button type="button" title="Refresh page">
        <svg viewBox="0 0 24 24" width="20" height="20" stroke="#3bb2d0" stroke-width="2" fill="none">
          <path d="M23 4v6h-6"></path>
          <path d="M1 20v-6h6"></path>
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
      </button>
    `;

        refreshControl.addEventListener('click', () => {
            window.location.reload();
        });

        // Add some CSS styling
        const style = document.createElement('style');
        style.textContent = `
      .mapboxgl-ctrl button {
        background-color: #fff;
        border: none;
        cursor: pointer;
        padding: 5px;
        border-radius: 4px;
      }
      .mapboxgl-ctrl button:hover {
        background-color: #f5f5f5;
      }
    `;
        document.head.appendChild(style);

        const customControl = {
            onAdd: function() {
                return refreshControl;
            },
            onRemove: function() {
                if (refreshControl.parentNode)
                    refreshControl.parentNode.removeChild(refreshControl);
                if (document.parentNode)
                    document.head.removeChild(style);
            }
        }

        mapboxControlRef.current = customControl;

        map.addControl(mapboxControlRef.current, 'bottom-left')

        // Add control to map
        // map.addControl({
        //     onAdd: function() {
        //         return refreshControl;
        //     },
        //     onRemove: function() {
        //         refreshControl.parentNode.removeChild(refreshControl);
        //         document.head.removeChild(style);
        //     }
        // }, 'bottom-left');


        return () => {
            map.removeLayer(id);
            map.removeSource(id);
            // if (mapboxControlRef.current && map.hasControl(mapboxControlRef.current))
            if (mapboxControlRef.current)
                map.removeControl(mapboxControlRef.current)
        };
    }, []);

    useEffect(() => {
        map.getSource(id).setData(positions);
    }, [positions]);

    return null;
}

export default AccuracyMap;